import Helper from '@ember/component/helper';
import { service } from '@ember/service';

export default class BuildFeed extends Helper {
  @service feeds;

  compute([feedObject], options = {}) {
    return this.feeds.buildFeed(feedObject, options)
  }
}
